import { Skeleton } from '@/new/components/skeleton';

export function EntityLoader() {
  return (
    <div className="relative rounded-md border border-gray-200">
      {/* Header Section Skeleton */}
      <div className="flex items-center justify-between rounded-t-md border-b bg-gray-50 px-5 py-4">
        <div className="flex items-center gap-3 flex-1">
          <Skeleton className="h-5 w-5 rounded-full" />
          <Skeleton className="h-5 w-48" />
        </div>
        <div className="ml-4">
          <Skeleton className="h-6 w-20 rounded-full" />
        </div>
      </div>

      {/* Content Section Skeleton */}
      <div className="flex flex-col gap-4 p-4">
        {/* Aliases Section Skeleton */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-32" />
        </div>

        {/* Description Section Skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>

        {/* Footer Section Skeleton */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-9 w-32" />
        </div>
      </div>
    </div>
  );
}
